import React from 'react'
import Preloader from '../../Global/Preloader';
import Headertwo from '../../Global/Headertwo';
import Servicedtlbred from '../Mainservicesdetails/Servicedtlbred';
import Servicesdetails from '../Mainservicesdetails/Servicesdetails';
import Ctaone from '../../Global/Ctaone';
import Footer from '../../Global/Footer';
import BackToTop from '../../Global/BackToTop';
import ContactForm from '../../Global/ContactForm';
import RealEstateBanner from '../../Services/Servicesdetails/RealEstateBanner';
import realEstateImage from '../../../assets/images/real-estate-management.jpg';
import realEstateImage1 from '../../../assets/images/real-estate-management-1.jpg';

const Main = () => {
    return (
        <>
            {/* <Preloader /> */}
            <Headertwo />
            {/* <Servicedtlbred title="Real Estate Management" /> */}
            <RealEstateBanner />

            <section className="real-estate-details py-5">
                <div className="container">
                    <div className="row align-items-center">
                        {/* Left side: Text */}
                        <div className="col-xl-7 col-lg-10">
                            <p>
                                From buying, selling, and renting to title transfers, legal support, and investment advice - we manage it all with integrity, urgency, and crystal-clear communication.
                            </p>
                            
                            <p>
                                Managing your property from overseas shouldn't feel like a never-ending project. That’s why we act as your trusted team on the ground - so you never have to chase agents, worry about disputes, or deal with unreliable vendors.
                            </p>

                            <h3 style={{ fontSize: '2.5em', marginTop: '2.5em' }}>Your property is our priority.</h3>
                        </div>

                        {/* Right side: Image */}
                        <div className="col-xl-5 col-lg-8 ms-auto">
                            <img
                                src={realEstateImage1}
                                alt="Why Choose The NRI Advisors"
                                className="img-fluid rounded" style={{ width: '90%', marginBottom: '15px'}}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xl-7 col-lg-7">
                            <p>Whether you’re an NRI based in Canada, the U.S., the UK, or the Middle East, dealing with property anywhere can mean navigating unclear paperwork, legal delays, builder issues, or maintenance chaos - often from thousands of miles away. At The NRI Advisors, we exist to make sure you don’t have to face those challenges alone.</p>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xl-12 col-lg-12">
                            <p>We are your one-stop team of real estate, legal, and property management professionals who work exclusively with NRIs. With deep local expertise across India and seamless global communication, we make sure your interests are protected at every step.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section
                className="what-we-offer"
                style={{
                    padding: '50px 0',
                    backgroundColor: 'rgb(242, 244, 248)',
                    color: '#222',
                    fontFamily: "'DM Sans', sans-serif",
                }}
            >
                <div className="container">
                    <h2
                        className="heading-title wow fadeInUp animated animated text-black"
                    >
                        What We Offer
                    </h2>

                    <div className="row gx-4 gy-4"> {/* Bootstrap gutter spacing: horizontal and vertical */}
                        {[
                            {
                                icon: '🏠',
                                title: 'Property Transactions',
                                points: ['Buying & Selling Support', 'Legal Due Diligence', 'Documentation & Registration'],
                            },
                            {
                                icon: '🔑',
                                title: 'Rental & Lease Management',
                                points: ['Tenant Onboarding', 'Rent Agreements', 'Income Monitoring'],
                            },
                            {
                                icon: '🛠️',
                                title: 'Maintenance & Security',
                                points: ['Site Visits & Emergency Repairs', 'Interior Work & Renovation Oversight', 'CCTV & Surveillance Setup'],
                            },
                            {
                                icon: '⚖️',
                                title: 'Legal & Dispute Resolution',
                                points: ['Title Conflicts', 'Tenant Evictions', 'Builder Delay Cases'],
                            },
                            {
                                icon: '📜',
                                title: 'Property Transfer',
                                points: ['Inheritance Transfers', 'Gift Deeds', 'Mutation Documentation'],
                            },
                            {
                                icon: '💡',
                                title: 'Investment & Financial Advisory',
                                points: ['Market Evaluation', 'ROI & Risk Analysis', 'Location-Based Investment Strategy'],
                            },
                            {
                                icon: '🏗️',
                                title: 'Construction & Design Management',
                                points: ['Interior Design', 'Contractor Supervision', 'Project Execution'],
                            },
                            {
                                icon: '📸',
                                title: 'Real-Time Monitoring',
                                points: ['Photo/Video Property Updates', 'Possession Status Reports', 'Legal/Notice Tracking'],
                            },
                        ].map(({ icon, title, points }) => (
                            <div key={title} className="col-lg-4 col-md-6">
                                <div
                                    className="h-100"
                                    style={{
                                        background: 'white',
                                        padding: '25px 30px',
                                        borderRadius: '15px',
                                        boxShadow: '0 15px 30px rgba(0,0,0,0.1)',
                                        transition: 'all 0.3s ease',
                                        height: '100%',
                                    }}
                                    onMouseEnter={e => {
                                        e.currentTarget.style.boxShadow = '0 25px 50px rgba(0,0,0,0.15)';
                                        e.currentTarget.style.transform = 'translateY(-5px)';
                                    }}
                                    onMouseLeave={e => {
                                        e.currentTarget.style.boxShadow = '0 15px 30px rgba(0,0,0,0.1)';
                                        e.currentTarget.style.transform = 'translateY(0)';
                                    }}
                                >
                                    <div
                                        style={{
                                            fontSize: '2.8rem',
                                            marginBottom: '15px',
                                            userSelect: 'none',
                                        }}
                                        aria-label={`${title} icon`}
                                        role="img"
                                    >
                                        {icon}
                                    </div>

                                    <h4
                                        style={{
                                            fontWeight: '700',
                                            marginBottom: '15px',
                                            color: '#000',
                                            letterSpacing: '0.7px',
                                        }}
                                    >
                                        {title}
                                    </h4>

                                    <ul
                                        style={{
                                            listStyleType: 'disc',
                                            paddingLeft: '20px',
                                            color: '#000',
                                            fontSize: '15px',
                                            lineHeight: '1.6',
                                            margin: 0,
                                        }}
                                    >
                                        {points.map(point => (
                                            <li key={point} style={{ marginBottom: '8px' }}>
                                                {point}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <div className="why-choose-two">
                <div className="container" id='about-will'>
                    <div className="row gutter-y-30">                        
                        <div className="col-lg-5">
                            <img
                                src={realEstateImage}
                                alt="Why Choose The NRI Advisors"
                                className="img-fluid rounded"
                            />
                        </div>

                        <div className="col-lg-7 align-self-center">
                            <div className="why-choose-right-two">
                                <div className="heading-box heading-white">
                                    <h2 className="heading-title wow fadeInUp animated animated text-black" style={{ marginTop: '0px', paddingTop: "0px", }}>
                                        Why Choose The NRI Advisors?
                                    </h2>
                                </div>

                                <ul className='features-one-list1' style={{ display: "flex", flexDirection: "column" }}>
                                    <li><b>No Travel Needed:</b> We handle everything remotely  - without you travelling</li>
                                    <li><b>Transparent Pricing:</b> No surprises. Clear estimates and honest fees.</li>
                                    <li><b>Tailored Services:</b> Every client’s situation is unique. We build custom solutions to match.</li>
                                    <li><b>One Point of Contact:</b> Your dedicated case manager coordinates everything</li>
                                    And more.
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div >

            <section
                className="five-step-process"
                style={{
                    backgroundColor: '#f7f9fb',
                    padding: '60px 0',
                    fontFamily: "'DM Sans', sans-serif",
                    color: '#000',
                }}
                >
                <div className="container">
                    <h2 className="heading-title wow fadeInUp animated animated mb-5 pb-0 text-center">
                    Our 5-Step Process
                    </h2>

                    <div className="timeline d-flex flex-column gap-5">
                    {[
                        {
                        title: 'Initial Consultation',
                        text: 'We start with an initial call to understand your needs and the details of your property.',
                        },
                        {
                        title: 'Custom Planning',
                        text: 'We develop a strategy - whether it’s buying, selling, renting, or dispute resolution - tailored just for you.',
                        },
                        {
                        title: 'End-to-End Execution',
                        text: 'Our team handles everything from site visits, vendor coordination, to legal work so you can stay stress-free.',
                        },
                        {
                        title: 'Real-Time Communication',
                        text: 'From regular updates to document status, you’re always in the loop with your personal case manager.',
                        },
                        {
                        title: 'Final Handover & Peace of Mind',
                        text: 'You get results - documented, completed, and clearly reported back to you - with no loose ends left behind.',
                        },
                    ].map((step, index) => (
                        <div
                        key={index}
                        className={`row align-items-center ${index % 2 === 0 ? '' : 'flex-row-reverse'}`}
                        >
                        <div className="col-md-6">
                            <h5 style={{ fontWeight: '600', fontSize: '1.2rem' }}>
                            <span
                                style={{
                                display: 'inline-block',
                                background: '#041021fa',
                                color: '#fff',
                                width: '30px',
                                height: '30px',
                                borderRadius: '50%',
                                textAlign: 'center',
                                lineHeight: '30px',
                                marginRight: '12px',
                                }}
                            >
                                {index + 1}
                            </span>
                            {step.title}
                            </h5>
                            <p style={{ marginTop: '10px', fontSize: '0.95rem', color: '#000' }}>{step.text}</p>
                        </div>
                        <div className="col-md-6 d-none d-md-block">
                            <div
                            style={{
                                height: '2px',
                                background: '#ddd',
                                margin: index % 2 === 0 ? '0 30px 0 0' : '0 0 0 30px',
                            }}
                            />
                        </div>
                        </div>
                    ))}
                    </div>
                </div>
            </section>

            <ContactForm />

            {/* <Servicesdetails />
            <Ctaone /> */}
            <Footer />
            {/* <BackToTop/> */}
        </>
    )
}
export default Main;